import { ShieldCheck, Building2, MapPin, FileText, BadgeCheck } from "lucide-react";
import { TRUST_SIGNALS } from "@/data/content";

const ICONS = { ShieldCheck, Building2, MapPin, FileText, BadgeCheck };

export default function TrustBar({ dark = true }) {
  return (
    <section data-testid="trust-bar" className={dark ? "bg-charcoal text-white" : "bg-offwhite text-charcoal border-y border-black/5"}>
      <div className="container-x py-6">
        <div className="flex flex-wrap items-center justify-between gap-x-8 gap-y-5">
          {TRUST_SIGNALS.map(({ icon, label }) => {
            const Icon = ICONS[icon];
            return (
              <div key={label} className="flex items-center gap-3" data-testid={`trust-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <Icon className="h-5 w-5 text-sand" strokeWidth={1.5} />
                <span className="text-xs uppercase tracking-[0.18em] font-medium">{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
